import isEqual from 'lodash/isEqual';
import React, { Component } from 'react';
import { OptionProps, components } from 'react-select';

import { CustomSelectProps, Option } from '@commons/Select/types';

import styles from './SelectOption.scss';
import Icon, { ICON_TYPES } from '@commons/Icon';

//----------------------------------------------------------------------
// TYPES
//----------------------------------------------------------------------

interface SelectOptionProps extends OptionProps<Option, false> {
  selectProps: Required<CustomSelectProps>;
}

//----------------------------------------------------------------------
// COMPONENT
//----------------------------------------------------------------------

class SelectOption extends Component<SelectOptionProps> {
  //----------------------------------------------------------------------
  // LIFECYCLE
  //----------------------------------------------------------------------

  shouldComponentUpdate(prevProps: SelectOptionProps) {
    const { isFocused, data } = this.props;
    return !isEqual(prevProps.isFocused, isFocused) || !isEqual(prevProps.data, data);
  }

  //----------------------------------------------------------------------
  // RENDER
  //----------------------------------------------------------------------

  render() {
    const { innerProps, data, isSelected } = this.props;

    return (
      <components.Option
        {...this.props}
        innerProps={{ ...innerProps, title: data.label }}
        className={styles.container}
      >
        <span className={styles.label}>{data.label}</span>
        {isSelected && <Icon type={ICON_TYPES.CHECKBOX} />}
      </components.Option>
    );
  }
}

export default SelectOption;
